export const protectedResources = {
  apiTodoList: {
    // endpoint: 'http://127.0.0.1:8000/',
    // endpoint: 'https://fastaimovies-webapp-backend-dev-app.azurewebsites.net/'
    endpoint: 'https://fastaimovieswebappbackendcopytest-app.azurewebsites.net/',
  },
  devCompanyId: ['18576303-bffc-495d-82c3-f22229532bab', '849a8bd3-69c3-4c08-b677-d61fcdbdbe98'],
};
